import React from 'react'
import Card from 'components/Card'
import './apiKeys.css'

export default function ApiKeys({ apiKeys }) {
    return (
        <React.Fragment>
            {
                apiKeys.map((key, i) => (
                    <Card inline key={i} title={ key.name }>
                        <div>***********{key.keyMask}</div>
                        {
                            key.scopes.map((scope, i) => {
                                return (<div key={i}>{scope.scope}: {
                                    scope.actions.length === 2 ? <span>Read, Write</span> : <span>Read</span>
                                }</div>)
                            })
                        }
                    </Card>
                ))
            }
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/ApiKeys/index.js